<template>
<div id="PD6060">
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4">
        <img id="photo" src="./img/PD6060/6060_1.png"/>
        <img id="photo" src="./img/PD6060/6060_2.png"/>
      </div>
      <div id="desc" class="col-sm-12 col-md-12 col-lg-8 col-xl-8">
        <!-- <div><h2 style="color: #00aeff">{{msg}}</h2></div> -->
        <p class="text">
          {{text}}
        </p>
        <table>
          <table style="margin:0 auto;">
            <thead>
              <tr>
                <th v-for="item in NameTableSecond">{{item}}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in item_table">
				<td :colspan="item.value ? 1 : 2">{{item.name}}</td>
				<td v-if="item.value">{{item.value}}</td>
              </tr>
            </tbody>
          </table>
        </table>
      </div>
    </div>
  </div>
    <div id="nineteen">

    </div>
</div>
</template>

<script>
export default {
  data () {
    return {
      msg: 'Опорно-поворотное устройство астросиб АВМ 700',
      text: 'Объектив представляет собой малоапертурный катадиоптрический широкопольный оптический прибор высокой светосилы со сферической оптикой, который выполнен по системе Шенкера с трехлинзовым полноапертурным корректором, с задним расположением фотоприёмного устройства в фокусе Кассегрена. Компоновка  и применённая оптическая схема  позволяют  использовать фотоприёмную аппаратуру произвольных габаритов и, в силу размещения вторичного зеркала на линзе полноапертурного корректора, избежать применения системы механических конструктивных элементов крепления вторичного зеркала - растяжек, что исключает помехи от них на изображении, и позволяет эффективно обнаруживать слабые точечные объекты вблизи ярких источников света (звезд) в поле зрения.',
      NameTableSecond: ['Наименование', 'Значение'],
      item_table:[
				{
					name: 'Тип сенсора',
					value: 'КМОП, GSENSE6060'
				},
				{
					name: 'Спектральный диапазон, нм',
					value: '400 ÷ 900'
				},
				{
					name: 'Размер чувствительного элемента (Г х В), мкм',
					value: '10 х 10'
				},
				{
					name: 'Размер регистрируемых кадров (Г х В), пикселей',
					value: '6000 х 6000 '
				},
				{
					name: 'Частота кадров серии, Гц',
					value: '4'
				},
				{
					name: 'Уровень насыщения, e',
					value: 'не менее 68000*'
				},
				{
					name: 'Квантовый выход макс, %',
					value: 'не менее 70* '
				},
				{
					name: 'Функция модуляции',
					value: 'не менее 0,5*'
				},
				{
					name: 'Разрядность, бит	',
					value: '2х12'
				},
				{
					name: 'Шум чтения, е',
					value: 'не более 3.5* '
				},
				{
					name: 'Динамический диапазон, дБ',
					value: 'не менее 68'
				},
				{
					name: 'Экспозиция, с',
					value: 'от 0 до 360'
				},
				{
					name: 'Охлаждение сенсора, °C',
					value: 'до минус 40 относительно окружающей среды, но не ниже минус 50'
				},
				{
					name: 'Точность поддержания температуры сенсора, °C',
					value: 'не хуже 0.4'
				},
				{
					name: 'Объем ОЗУ, Гб',
					value: '8'
				},
				{
					name: 'Интерфейс передачи выходных данных',
					value: 'Ethernet 1000BASE-TX'
				},
				{
					name: 'Сигнал управления затвором',
					value: 'ТТЛ 3.3В'
				},
				{
					name: 'Сигнал открытия затвора',
					value: 'ТТЛ 3.3В'
				},
				{
					name: 'Секундный импульс 1PPS (внешний)',
					value: 'ТТЛ 3.3В, 5мА. Общая длительность сигнала 125 мкс. Время нарастания и спада сигнала не более 20нс.'
				},
				{
					name: 'Интерфейс временной синхронизации',
					value: 'Ethernet'
				},
				{
					name: 'Формат выходных данных изображения',
					value: 'FITS'
				},
				{
					name: 'Напряжение питания, В',
					value: '11 ÷ 14'
				},
				{
					name: 'Максимальная мощность, Вт',
					value: 'не более 120 '
				},
				{
					name: 'Габариты, мм',
					value: 'не более Ø180x150'
				},
				{
					name: 'Вес, кг',
					value: '4.5'
				},
				{
					name: 'Интерфейс выходных данных изображения',
					value: 'Gigabit Ethernet 1000BASE-TX'
				},
				{
					name: 'Интерфейс управления и синхронизации',
					value: 'Gigabit Ethernet 1000BASE-TX'
				},
				{
					name: 'Интерфейс получения сигнала временной синхронизации от внешнего источника',
					value: 'Ethernet'
				},
				{
					name: 'Временная синхронизация',
					value: 'Секундный импульс 1PPS'
				},
				{
					name: 'Тип и характеристика внешнего сигнала временной синхронизации',
					value: 'ТТЛ 3.3В, 5мА. Общая длительность сигнала 125 мкс. Время нарастания и спада сигнала не более 20нс.'
				},
			],

}
  },
  computed: {
  },
  methods: {}
}
</script>

<style scoped>
#PD6060 {
    height: 100%;
    color: white;
}
img#photo{
  margin-top: 13%;
  width: 90%;
}
div #caption{
	color: #78daff;
	opacity: 0.9;
	text-decoration: underline;
}
div#desc{
  width: 100%;
}
div#desc p.text{
  text-align: justify;
}
table{
  table-layout: fixed;
}

</style>